// vendor
import { SetupContext } from "@vue/composition-api";

export const setQueryValue = (k:string, v:any, context:SetupContext) => {
	const q:any = { ...context.root.$route.query };
	if(v !== undefined && v !== null){
		q[k] = v;
	}
	else {
		delete q[k];
	}
	context.root.$router.push({ query: q})
	.catch(() => {});
};

export const getQueryValue = (k:string, context:SetupContext) => {
	return context.root.$route.query[k] as any;
};